// extracted by mini-css-extract-plugin
export default {"suggestionbox":"style_suggestionbox__ReYbv","flipX":"style_flipX__WB9Ni"};